// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./login.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./register.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./feedback.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Open Dyslexic", Arial, sans-serif;
  background-color: var(--background-color);
  margin: 0;
  padding: 0;
  overflow-y: auto !important;
  height: 100%;
}

.app {
  display: flex;
  flex-direction: column;
  justify-content: center; /* Centrado vertical */
  align-items: center; /* Centrado horizontal */
  height: 100vh; /* Asegura que ocupe toda la altura visible */
  margin: 0; /* Por si hay algún margen sobrante */
  padding: 0; /* Por si hay algún padding sobrante */
}

textarea {
  font-family: inherit;
}

.up-content {
  display: flex;
  width: 90%;
  align-items: center;
  margin-top: 50px;
  justify-content: center;
}

.text-perfil-button {
  margin-left: 5px;
}

.perfil-button-container {
  position: relative;
  display: inline-block;
  padding-left: 0px;
}

.main-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 70%;
  max-height: 90vh;
  /* background-color: yellow; */
  overflow: hidden;
}

.chat-container {
  display: flex;
  width: 100%;
  min-height: 40vh;
  flex-direction: column;
  /* background-color: red; */
}

.chat-log {
  flex: 1 1;
  overflow-y: auto;
  max-height: 66vh;
  padding-right: 20px;
}

/* Chrome, Safari, Edge */
.chat-log::-webkit-scrollbar {
  width: 8px;
}

.chat-log::-webkit-scrollbar-track {
  background: transparent;
}

.chat-log::-webkit-scrollbar {
  width: 8px;
}

.chat-log::-webkit-scrollbar-thumb {
  background-color: #4b5563; /* Gris frío oscuro */
  border-radius: 8px;
}

.chat-log::-webkit-scrollbar-thumb:hover {
  background-color: #64748b; /* Hover más claro y moderno */
}

.chat-log::-webkit-scrollbar-track {
  background-color: transparent;
}

.chat-log::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: center;
  z-index: -1;
}

.image-container {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 20px;
}

.image-container img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 8px;
}

.chat-message {
  display: flex;
  align-items: flex-start;
  max-width: 80%;
  padding: 12px;
  margin: 10px;
  border-radius: 12px;
  font-size: 15px;
  line-height: 1.4;
}

/* Mensajes del usuario */
.chat-message.user {
  align-self: flex-end;
  margin-left: auto;
  /* Azul grisáceo elegante */
  background: linear-gradient(
    135deg,
    rgba(148, 163, 184, 0.08),
    rgba(100, 116, 139, 0.06)
  );
  color: rgba(232, 232, 232, 0.988);
  border-bottom-right-radius: 0;
  text-align: right;
  /* justify-content: flex-end;  */
  align-items: flex-end;
  width: fit-content;
}

/* Mensajes del bot */
.chat-message.bot {
  align-self: flex-start;
  /* background-color: #000000; */
  color: #ffffff;
  border-bottom-left-radius: 0;
  text-align: left;
  justify-content: flex-start;
  align-items: flex-start;
  width: fit-content;
}

/* Asegurar que el texto del usuario también esté alineado a la derecha */
.chat-message.user .chat-message-content {
  text-align: right;
}

.chat-message-content {
  max-width: 100%;
  word-wrap: break-word;
}

.bot-avatar img {
  margin-top: -4px;
}

.upload-form {
  display: flex;
  align-items: center;
  margin-top: 10px;
  gap: 10px;
  flex-wrap: wrap;
}

.upload-button {
  background-color: var(--color-dark);
  color: var(--button-text-color);
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 12px;
  padding-right: 12px;
  border: none;
  text-align: center;
  justify-content: center;
  border-radius: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 0px;
  width: fit-content;
}

.upload-button:hover {
  background-color: var(--accent-color);
  transform: scale(1.01);
}

.questions-button-container {
  margin-top: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.questions-button {
  background-color: var(--secondary-color);
  color: var(--button-text-color);
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: 100%;
}

.questions-button:hover {
  background-color: var(--secondary-hover-color);
}

.voice-controls {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.send-transcript-button {
  background-color: var(--secondary-color);
  color: var(--button-text-color);
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 0 10px;
}

.send-transcript-button:hover {
  background-color: var(--secondary-hover-color);
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  background-color: var(--text-color);
  color: white;
}

.status-message {
  color: var(--primary-color);
  font-weight: bold;
  margin: 10px 0;
}

.playback-rate-control {
  display: flex;
  align-items: center;
  margin: 10px 0;
}

.playback-rate-control label {
  margin-right: 10px;
}

.playback-rate-control input {
  margin-right: 10px;
}

.file-upload input {
  display: none;
}

.file-upload label {
  cursor: pointer;
}

input[type="text"] {
  flex: 1 1;
  padding: 10px;
  margin-right: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: 100%;
}

/* Contenedor general */
.audio-controls {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 1rem;
}

/* Botones de audio y feedback */
.feedback-button {
  background: none;
  border: none;
  color: #94a3b8;
  font-size: 16px;
  cursor: pointer;
  transition: color 0.25s ease, transform 0.2s ease;
}

.feedback-button:hover {
  color: #e2e8f0;
  transform: scale(1.05);
}

/* Cuando ya se dio feedback */
.feedback-button-disabled {
  color: #4ea8d1;
  cursor: default;
  opacity: 1;
  pointer-events: none;
  transform: none;
}

/* Botón de cerrar */
.feedback-button-close {
  font-size: 14px;
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  transition: color 0.3s ease;
}

.feedback-button-close:hover {
  color: #e2e8f0;
}

/* Selector de velocidad (botones) */
.adjust-rate-button {
  background-color: #2b3544;
  color: #e2e8f0;
  border: 1px solid #3b4452;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease-in-out;
}

.adjust-rate-button:hover {
  background-color: #384150;
  transform: scale(1.05);
}

.adjust-rate-button.selected {
  background-color: #475569;
  color: #f8fafc;
  border-color: #64748b;
}

/* Selector tipo <select> */
.adjust-rate-select {
  background-color: #1f2937;
  color: #e2e8f0;
  border: 1px solid #3b4452;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
}

.resume-button,
.pause-button {
  background-color: #444444;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 18px;
  cursor: pointer;
  font-weight: 500;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
  margin-left: 10px;
}

.resume-button:hover,
.pause-button:hover {
  background-color: #555555;
  box-shadow: 0px 5px 12px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
}

.files-button {
  background-color: var(--secondary-color);
  color: var(--button-text-color);
  border: none;
  text-align: center;
  position: relative;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
}

h2 {
  margin-top: 0;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

li {
  margin-bottom: 10px;
}

.file-item svg {
  margin-right: 10px;
}

.file-item {
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
  text-align: left;
}

.file-item:hover {
  background: #e0e0e0;
}

.file-item .fa-file-download {
  margin-right: 8px;
}

.form-container {
  background-color: #ffffff;
  padding: 20px;
  max-width: 400px;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.form-header {
  text-align: center;
}

.form-logo {
  max-width: 150px;
}

.form-body {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #333;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.error {
  color: red;
  font-size: 0.875em;
}

.form-buttons {
  display: flex;
  justify-content: space-between;
}

.btn-register,
.btn-cancel {
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-register {
  background-color: #007bff;
  color: #fff;
}

.btn-cancel {
  background-color: #6c757d;
  color: #fff;
}

.btn-register:hover {
  background-color: #0056b3;
}

.btn-cancel:hover {
  background-color: #5a6268;
}

input[type="text"] {
  height: 35px;
}

@media (max-width: 480px) {
  .chat-log {
    height: 100px;
  }

  .audio-controls button {
    font-size: 1em;
  }

  .footer {
    padding: 5px 10px;
  }

  .chat-message p {
    font-size: 14px;
  }

  /* .chat-submit-button,
  .upload-button,
  .questions-button {
    padding: 10px;
    font-size: 14px;
  } */

  .button-text {
    display: none;
  }

  .audio-controls {
    gap: 5px;
  }

  .audio-button,
  .resume-button,
  .pause-button,
  .adjust-rate-button {
    width: 50px;
    font-size: 1em;
    padding: 4px;
    margin: 4px 4px;
    text-align: center;
  }

  .adjust-rate-select {
    font-size: 1em;
    padding: 4px;
    margin: 4px 0;
  }

  .adjust-rate-button {
    display: none;
  }
}

@media (max-width: 1200px) {
  .main-content {
    min-width: 100%;
    padding: 10px;
  }
}

@media (max-width: 768px) {
  .chat-container {
    flex-direction: column;
    align-items: center;
  }

  .chat-log {
    width: 90%;
    margin-bottom: 10px;
  }

  .image-container {
    width: 100%;
    padding-left: 0;
  }

  .image-container img {
    width: 80%;
    max-height: 200px;
  }

  .chat-form {
    flex-direction: column;
  }

  .chat-submit-button {
    width: 100%;
  }

  .upload-form {
    flex-direction: column;
  }

  .upload-button {
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }

  .questions-button-container {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .questions-button {
    width: 100%;
  }

  .audio-controls {
    flex-direction: column;
    align-items: center;
    gap: 5px;
  }

  .audio-button,
  .resume-button,
  .pause-button,
  .adjust-rate-button {
    font-size: 1.2em;
    padding: 5px;
    margin: 5px 0;
    width: 50px;
    text-align: center;
  }

  .adjust-rate-select {
    width: 50px;
    font-size: 1.2em;
    padding: 10px;
    margin: 5px 5px;
    text-align: center;
    border: 2px solid #ccc;
    border-radius: 8px;
    background-color: #f9f9f9;
    color: #333;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    cursor: pointer;
    transition: background-color 0.3s ease, border-color 0.3s ease;
  }

  .adjust-rate-select:focus {
    outline: none; /* Quitar el borde de enfoque predeterminado */
    border-color: #007bff; /* Cambiar el color del borde al enfocar */
    background-color: #e9f7fe; /* Cambiar el color de fondo al enfocar */
  }

  .adjust-rate-select:hover {
    background-color: #f1f1f1; /* Cambiar el color de fondo al pasar por encima */
  }
}

/* Media queries para la responsividad */
@media (max-width: 1280px) {
  .main-content {
    min-width: 90%;
    min-height: 70vh; /* Incrementa la altura mínima en pantallas más pequeñas */
    height: auto; /* Permite que el contenido determine la altura */
    padding: 10px;
  }

  .chat-container {
    flex-direction: column;
    height: auto;
  }

  .chat-log {
    max-height: 50vh; /* Ajusta la altura máxima en pantallas más pequeñas */
    margin-bottom: 20px;
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(
    15,
    23,
    42,
    0.6
  ); /* similar al fondo general con oscurecimiento */
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(6px);
  z-index: 1000;
}

.modal-content {
  background-color: #1f2937;
  color: #f1f5f9;
  padding: 24px;
  border-radius: 16px;
  max-width: 90%;
  max-height: 90%;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.5);
}

.modal-close {
  position: absolute;
  top: 14px;
  right: 14px;
  background: none;
  border: none;
  font-size: 22px;
  color: #94a3b8;
  cursor: pointer;
  transition: color 0.2s ease, transform 0.2s ease;
}

.modal-close:hover {
  color: #f1f5f9;
  transform: scale(1.2);
}

.concept-m ap-actions {
  color: var(--button-text-color);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 0 10px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAIA;EACE,+CAA+C;EAC/C,yCAAyC;EACzC,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,sBAAsB;EAC/C,mBAAmB,EAAE,wBAAwB;EAC7C,aAAa,EAAE,6CAA6C;EAC5D,SAAS,EAAE,qCAAqC;EAChD,UAAU,EAAE,sCAAsC;AACpD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,iBAAiB;EACjB,2BAA2B;EAC3B;;;;GAIC;EACD,iCAAiC;EACjC,6BAA6B;EAC7B,iBAAiB;EACjB,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,yEAAyE;AACzE;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;KAKG;;EAEH;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;;;;IAIE,WAAW;IACX,cAAc;IACd,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;;;;IAIE,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,eAAe;IACf,8DAA8D;EAChE;;EAEA;IACE,aAAa,EAAE,8CAA8C;IAC7D,qBAAqB,EAAE,0CAA0C;IACjE,yBAAyB,EAAE,yCAAyC;EACtE;;EAEA;IACE,yBAAyB,EAAE,kDAAkD;EAC/E;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,cAAc;IACd,gBAAgB,EAAE,0DAA0D;IAC5E,YAAY,EAAE,iDAAiD;IAC/D,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,gBAAgB,EAAE,sDAAsD;IACxE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;GAKC,EAAE,gDAAgD;EACnD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB","sourcesContent":["@import \"./login.css\";\n@import \"./register.css\";\n@import \"./feedback.css\";\n\nbody {\n  font-family: \"Open Dyslexic\", Arial, sans-serif;\n  background-color: var(--background-color);\n  margin: 0;\n  padding: 0;\n  overflow-y: auto !important;\n  height: 100%;\n}\n\n.app {\n  display: flex;\n  flex-direction: column;\n  justify-content: center; /* Centrado vertical */\n  align-items: center; /* Centrado horizontal */\n  height: 100vh; /* Asegura que ocupe toda la altura visible */\n  margin: 0; /* Por si hay algún margen sobrante */\n  padding: 0; /* Por si hay algún padding sobrante */\n}\n\ntextarea {\n  font-family: inherit;\n}\n\n.up-content {\n  display: flex;\n  width: 90%;\n  align-items: center;\n  margin-top: 50px;\n  justify-content: center;\n}\n\n.text-perfil-button {\n  margin-left: 5px;\n}\n\n.perfil-button-container {\n  position: relative;\n  display: inline-block;\n  padding-left: 0px;\n}\n\n.main-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 70%;\n  max-height: 90vh;\n  /* background-color: yellow; */\n  overflow: hidden;\n}\n\n.chat-container {\n  display: flex;\n  width: 100%;\n  min-height: 40vh;\n  flex-direction: column;\n  /* background-color: red; */\n}\n\n.chat-log {\n  flex: 1;\n  overflow-y: auto;\n  max-height: 66vh;\n  padding-right: 20px;\n}\n\n/* Chrome, Safari, Edge */\n.chat-log::-webkit-scrollbar {\n  width: 8px;\n}\n\n.chat-log::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.chat-log::-webkit-scrollbar {\n  width: 8px;\n}\n\n.chat-log::-webkit-scrollbar-thumb {\n  background-color: #4b5563; /* Gris frío oscuro */\n  border-radius: 8px;\n}\n\n.chat-log::-webkit-scrollbar-thumb:hover {\n  background-color: #64748b; /* Hover más claro y moderno */\n}\n\n.chat-log::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.chat-log::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-size: contain;\n  background-position: center;\n  z-index: -1;\n}\n\n.image-container {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-left: 20px;\n}\n\n.image-container img {\n  max-width: 100%;\n  max-height: 100%;\n  border-radius: 8px;\n}\n\n.chat-message {\n  display: flex;\n  align-items: flex-start;\n  max-width: 80%;\n  padding: 12px;\n  margin: 10px;\n  border-radius: 12px;\n  font-size: 15px;\n  line-height: 1.4;\n}\n\n/* Mensajes del usuario */\n.chat-message.user {\n  align-self: flex-end;\n  margin-left: auto;\n  /* Azul grisáceo elegante */\n  background: linear-gradient(\n    135deg,\n    rgba(148, 163, 184, 0.08),\n    rgba(100, 116, 139, 0.06)\n  );\n  color: rgba(232, 232, 232, 0.988);\n  border-bottom-right-radius: 0;\n  text-align: right;\n  /* justify-content: flex-end;  */\n  align-items: flex-end;\n  width: fit-content;\n}\n\n/* Mensajes del bot */\n.chat-message.bot {\n  align-self: flex-start;\n  /* background-color: #000000; */\n  color: #ffffff;\n  border-bottom-left-radius: 0;\n  text-align: left;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: fit-content;\n}\n\n/* Asegurar que el texto del usuario también esté alineado a la derecha */\n.chat-message.user .chat-message-content {\n  text-align: right;\n}\n\n.chat-message-content {\n  max-width: 100%;\n  word-wrap: break-word;\n}\n\n.bot-avatar img {\n  margin-top: -4px;\n}\n\n.upload-form {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.upload-button {\n  background-color: var(--color-dark);\n  color: var(--button-text-color);\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-left: 12px;\n  padding-right: 12px;\n  border: none;\n  text-align: center;\n  justify-content: center;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  margin-right: 0px;\n  width: fit-content;\n}\n\n.upload-button:hover {\n  background-color: var(--accent-color);\n  transform: scale(1.01);\n}\n\n.questions-button-container {\n  margin-top: 10px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.questions-button {\n  background-color: var(--secondary-color);\n  color: var(--button-text-color);\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  width: 100%;\n}\n\n.questions-button:hover {\n  background-color: var(--secondary-hover-color);\n}\n\n.voice-controls {\n  display: flex;\n  justify-content: center;\n  margin-top: 10px;\n}\n\n.send-transcript-button {\n  background-color: var(--secondary-color);\n  color: var(--button-text-color);\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin: 0 10px;\n}\n\n.send-transcript-button:hover {\n  background-color: var(--secondary-hover-color);\n}\n\n.footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 20px;\n  background-color: var(--text-color);\n  color: white;\n}\n\n.status-message {\n  color: var(--primary-color);\n  font-weight: bold;\n  margin: 10px 0;\n}\n\n.playback-rate-control {\n  display: flex;\n  align-items: center;\n  margin: 10px 0;\n}\n\n.playback-rate-control label {\n  margin-right: 10px;\n}\n\n.playback-rate-control input {\n  margin-right: 10px;\n}\n\n.file-upload input {\n  display: none;\n}\n\n.file-upload label {\n  cursor: pointer;\n}\n\ninput[type=\"text\"] {\n  flex: 1;\n  padding: 10px;\n  margin-right: 10px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  width: 100%;\n}\n\n/* Contenedor general */\n.audio-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-top: 1rem;\n}\n\n/* Botones de audio y feedback */\n.feedback-button {\n  background: none;\n  border: none;\n  color: #94a3b8;\n  font-size: 16px;\n  cursor: pointer;\n  transition: color 0.25s ease, transform 0.2s ease;\n}\n\n.feedback-button:hover {\n  color: #e2e8f0;\n  transform: scale(1.05);\n}\n\n/* Cuando ya se dio feedback */\n.feedback-button-disabled {\n  color: #4ea8d1;\n  cursor: default;\n  opacity: 1;\n  pointer-events: none;\n  transform: none;\n}\n\n/* Botón de cerrar */\n.feedback-button-close {\n  font-size: 14px;\n  background: none;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  transition: color 0.3s ease;\n}\n\n.feedback-button-close:hover {\n  color: #e2e8f0;\n}\n\n/* Selector de velocidad (botones) */\n.adjust-rate-button {\n  background-color: #2b3544;\n  color: #e2e8f0;\n  border: 1px solid #3b4452;\n  border-radius: 6px;\n  padding: 6px 10px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.25s ease-in-out;\n}\n\n.adjust-rate-button:hover {\n  background-color: #384150;\n  transform: scale(1.05);\n}\n\n.adjust-rate-button.selected {\n  background-color: #475569;\n  color: #f8fafc;\n  border-color: #64748b;\n}\n\n/* Selector tipo <select> */\n.adjust-rate-select {\n  background-color: #1f2937;\n  color: #e2e8f0;\n  border: 1px solid #3b4452;\n  border-radius: 6px;\n  padding: 6px 10px;\n  font-size: 13px;\n}\n\n.resume-button,\n.pause-button {\n  background-color: #444444;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 18px;\n  cursor: pointer;\n  font-weight: 500;\n  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease-in-out;\n  margin-left: 10px;\n}\n\n.resume-button:hover,\n.pause-button:hover {\n  background-color: #555555;\n  box-shadow: 0px 5px 12px rgba(0, 0, 0, 0.2);\n  transform: translateY(-2px);\n}\n\n.files-button {\n  background-color: var(--secondary-color);\n  color: var(--button-text-color);\n  border: none;\n  text-align: center;\n  position: relative;\n  display: inline-block;\n  font-size: 16px;\n  cursor: pointer;\n}\n\nh2 {\n  margin-top: 0;\n}\n\nul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\nli {\n  margin-bottom: 10px;\n}\n\n.file-item svg {\n  margin-right: 10px;\n}\n\n.file-item {\n  background: #f0f0f0;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n}\n\n.file-item:hover {\n  background: #e0e0e0;\n}\n\n.file-item .fa-file-download {\n  margin-right: 8px;\n}\n\n.form-container {\n  background-color: #ffffff;\n  padding: 20px;\n  max-width: 400px;\n  margin: 0 auto;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.form-header {\n  text-align: center;\n}\n\n.form-logo {\n  max-width: 150px;\n}\n\n.form-body {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n  color: #333;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.error {\n  color: red;\n  font-size: 0.875em;\n}\n\n.form-buttons {\n  display: flex;\n  justify-content: space-between;\n}\n\n.btn-register,\n.btn-cancel {\n  padding: 10px 15px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.btn-register {\n  background-color: #007bff;\n  color: #fff;\n}\n\n.btn-cancel {\n  background-color: #6c757d;\n  color: #fff;\n}\n\n.btn-register:hover {\n  background-color: #0056b3;\n}\n\n.btn-cancel:hover {\n  background-color: #5a6268;\n}\n\ninput[type=\"text\"] {\n  height: 35px;\n}\n\n@media (max-width: 480px) {\n  .chat-log {\n    height: 100px;\n  }\n\n  .audio-controls button {\n    font-size: 1em;\n  }\n\n  .footer {\n    padding: 5px 10px;\n  }\n\n  .chat-message p {\n    font-size: 14px;\n  }\n\n  /* .chat-submit-button,\n  .upload-button,\n  .questions-button {\n    padding: 10px;\n    font-size: 14px;\n  } */\n\n  .button-text {\n    display: none;\n  }\n\n  .audio-controls {\n    gap: 5px;\n  }\n\n  .audio-button,\n  .resume-button,\n  .pause-button,\n  .adjust-rate-button {\n    width: 50px;\n    font-size: 1em;\n    padding: 4px;\n    margin: 4px 4px;\n    text-align: center;\n  }\n\n  .adjust-rate-select {\n    font-size: 1em;\n    padding: 4px;\n    margin: 4px 0;\n  }\n\n  .adjust-rate-button {\n    display: none;\n  }\n}\n\n@media (max-width: 1200px) {\n  .main-content {\n    min-width: 100%;\n    padding: 10px;\n  }\n}\n\n@media (max-width: 768px) {\n  .chat-container {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .chat-log {\n    width: 90%;\n    margin-bottom: 10px;\n  }\n\n  .image-container {\n    width: 100%;\n    padding-left: 0;\n  }\n\n  .image-container img {\n    width: 80%;\n    max-height: 200px;\n  }\n\n  .chat-form {\n    flex-direction: column;\n  }\n\n  .chat-submit-button {\n    width: 100%;\n  }\n\n  .upload-form {\n    flex-direction: column;\n  }\n\n  .upload-button {\n    width: 100%;\n    margin-right: 0;\n    margin-bottom: 10px;\n  }\n\n  .questions-button-container {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n\n  .questions-button {\n    width: 100%;\n  }\n\n  .audio-controls {\n    flex-direction: column;\n    align-items: center;\n    gap: 5px;\n  }\n\n  .audio-button,\n  .resume-button,\n  .pause-button,\n  .adjust-rate-button {\n    font-size: 1.2em;\n    padding: 5px;\n    margin: 5px 0;\n    width: 50px;\n    text-align: center;\n  }\n\n  .adjust-rate-select {\n    width: 50px;\n    font-size: 1.2em;\n    padding: 10px;\n    margin: 5px 5px;\n    text-align: center;\n    border: 2px solid #ccc;\n    border-radius: 8px;\n    background-color: #f9f9f9;\n    color: #333;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    cursor: pointer;\n    transition: background-color 0.3s ease, border-color 0.3s ease;\n  }\n\n  .adjust-rate-select:focus {\n    outline: none; /* Quitar el borde de enfoque predeterminado */\n    border-color: #007bff; /* Cambiar el color del borde al enfocar */\n    background-color: #e9f7fe; /* Cambiar el color de fondo al enfocar */\n  }\n\n  .adjust-rate-select:hover {\n    background-color: #f1f1f1; /* Cambiar el color de fondo al pasar por encima */\n  }\n}\n\n/* Media queries para la responsividad */\n@media (max-width: 1280px) {\n  .main-content {\n    min-width: 90%;\n    min-height: 70vh; /* Incrementa la altura mínima en pantallas más pequeñas */\n    height: auto; /* Permite que el contenido determine la altura */\n    padding: 10px;\n  }\n\n  .chat-container {\n    flex-direction: column;\n    height: auto;\n  }\n\n  .chat-log {\n    max-height: 50vh; /* Ajusta la altura máxima en pantallas más pequeñas */\n    margin-bottom: 20px;\n  }\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(\n    15,\n    23,\n    42,\n    0.6\n  ); /* similar al fondo general con oscurecimiento */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  backdrop-filter: blur(6px);\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: #1f2937;\n  color: #f1f5f9;\n  padding: 24px;\n  border-radius: 16px;\n  max-width: 90%;\n  max-height: 90%;\n  overflow-y: auto;\n  position: relative;\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.5);\n}\n\n.modal-close {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  background: none;\n  border: none;\n  font-size: 22px;\n  color: #94a3b8;\n  cursor: pointer;\n  transition: color 0.2s ease, transform 0.2s ease;\n}\n\n.modal-close:hover {\n  color: #f1f5f9;\n  transform: scale(1.2);\n}\n\n.concept-m ap-actions {\n  color: var(--button-text-color);\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin: 0 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
